module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input class="file-transfer-input" type="file" name="fichier" accept=".jpg"></input>\r\n<span class="add ui-icon ui-icon-plus"></span>\r\n<span class="remove ui-icon ui-icon-minus"></span>';
}
return __p;
};
